import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LegislationGroup } from 'app/legislation/legislation-items/legislation';

@Component({
    selector: 'app-edit-group-dialog',
    templateUrl: './add-edit-group-dialog.component.html',
    styleUrls: ['./add-edit-group-dialog.component.scss'],
})
export class AddEditLegislationGroupDialogComponent implements OnInit {
    title = 'Legislation Group';
    legislationGroup: LegislationGroup;
    listOfGroupNames: string[];
    groupEditorForm: FormGroup;
    
    get groupName() {
        return this.groupEditorForm.get('GroupName') as FormControl;
    }

    constructor(
        private dialogRef: MatDialogRef<AddEditLegislationGroupDialogComponent>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.legislationGroup = data.legislationGroup;
        this.listOfGroupNames = data.groupNames;
    }

    ngOnInit(): void {
        const self = this;
        self.groupEditorForm = self.formBuilder.group({
            GroupName: [self.legislationGroup.groupName, [
                Validators.required, 
                isNameTaken(self.legislationGroup.groupName, self.listOfGroupNames)
            ]],
        });

        self.title = self.data.title;
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues): void {
        const self = this;

        self.groupEditorForm.markAllAsTouched();

        if (this.groupEditorForm.valid) {
            self.legislationGroup.groupName = formValues.GroupName;

            self.dialogRef.close(self.legislationGroup);
            self.groupEditorForm.reset();
        }
    }
}

/* Validation function to see if the inputted recipient name already exists. If so, the field will become invalid.
 * This error will NOT occurr if, while editing an existing recipient name, the user reverts changes to match the
 * original name provide to the form prior to saving.
 */
function isNameTaken(name: string, listofnames?: string[]): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
        let error = null;
        if (listofnames) {
            const isNameTaken = listofnames.some((value) => value === control.value);
            error = isNameTaken && control.dirty && control.value !== name ? { isNameTaken: true } : null;
        }
        return error;
    };
}
